// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomThread = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.6584 7.95757C11.6005 7.93005 11.5418 7.90355 11.4822 7.87819C11.3786 5.98187 10.3348 4.89623 8.58209 4.88512C8.57415 4.88507 8.56625 4.88507 8.55831 4.88507C7.50998 4.88507 6.6381 5.32928 6.10147 6.1376L7.06539 6.794C7.46627 6.19021 8.09543 6.0615 8.55877 6.0615C8.56412 6.0615 8.5695 6.0615 8.57479 6.06155C9.15188 6.0652 9.58736 6.23176 9.86921 6.55658C10.0743 6.79306 10.2115 7.11985 10.2794 7.53226C9.76777 7.44594 9.21442 7.41939 8.62288 7.45306C6.95651 7.54835 5.88524 8.5131 5.95719 9.85366C5.9937 10.5337 6.33496 11.1187 6.91806 11.5008C7.41106 11.8239 8.04602 11.9819 8.70594 11.9461C9.57742 11.8987 10.2611 11.5686 10.7381 10.9651C11.1003 10.5067 11.3294 9.91276 11.4305 9.16436C11.8459 9.41318 12.1537 9.74061 12.3237 10.1342C12.6127 10.8033 12.6296 11.9028 11.7258 12.7992C10.934 13.5845 9.98219 13.9242 8.54372 13.9347C6.94808 13.923 5.74132 13.415 4.95672 12.4248C4.222 11.4977 3.8423 10.1585 3.82813 8.4445C3.8423 6.73046 4.222 5.39128 4.95672 4.46413C5.74132 3.47401 6.94806 2.96603 8.5437 2.95426C10.1509 2.96612 11.3787 3.47654 12.1933 4.47144C12.5928 4.95933 12.894 5.57289 13.0925 6.28827L14.2221 5.9891C13.9814 5.10854 13.6027 4.34976 13.0874 3.72047C12.0431 2.44496 10.5157 1.79138 8.54764 1.77783H8.53976C6.57574 1.79134 5.06543 2.4474 4.05081 3.72778C3.14793 4.86717 2.6822 6.45253 2.66655 8.43981L2.6665 8.4445L2.66655 8.44919C2.6822 10.4364 3.14793 12.0219 4.05081 13.1612C5.06543 14.4416 6.57574 15.0977 8.53976 15.1112H8.54764C10.2938 15.0992 11.5246 14.6453 12.5385 13.6397C13.8651 12.3241 13.8251 10.675 13.3879 9.66262C13.0742 8.93665 12.4762 8.34701 11.6584 7.95757ZM8.64355 10.7714C7.91321 10.8122 7.15447 10.4868 7.11705 9.78978C7.08932 9.27297 7.48755 8.6963 8.68837 8.62761C8.82589 8.61973 8.96083 8.61589 9.0934 8.61589C9.52957 8.61589 9.93762 8.65795 10.3086 8.73846C10.1702 10.4539 9.3586 10.7324 8.64355 10.7714Z',
      fill: 'black',
    }),
  );

export { IconCustomThread };
